import axios, { AxiosInstance } from 'axios';

import { Configuration } from 'src/Services/API/generated';
import {
  CreateTaskDto,
  MyTaskSummaryDto,
  RelatedEntityType,
  TaskDto,
  UpdateTaskDto,
} from 'src/types/task.types';

export class TaskApi {
  private axiosInstance: AxiosInstance;
  private basePath: string;

  constructor(configuration: Configuration) {
    this.basePath = configuration.basePath ?? '';
    this.axiosInstance = axios.create({
      baseURL: this.basePath,
      ...configuration.baseOptions,
    });
  }

  async create(assetId: string, data: CreateTaskDto): Promise<TaskDto> {
    const response = await this.axiosInstance.post<TaskDto>(`/assets/${assetId}/tasks`, data);
    return response.data;
  }

  async findAll(assetId: string): Promise<TaskDto[]> {
    const response = await this.axiosInstance.get<TaskDto[]>(`/assets/${assetId}/tasks`);
    return response.data;
  }

  async findOne(assetId: string, taskId: string): Promise<TaskDto> {
    const response = await this.axiosInstance.get<TaskDto>(`/assets/${assetId}/tasks/${taskId}`);
    return response.data;
  }

  async update(assetId: string, taskId: string, data: UpdateTaskDto): Promise<TaskDto> {
    const response = await this.axiosInstance.patch<TaskDto>(
      `/assets/${assetId}/tasks/${taskId}`,
      data
    );
    return response.data;
  }

  async delete(assetId: string, taskId: string): Promise<void> {
    await this.axiosInstance.delete(`/assets/${assetId}/tasks/${taskId}`);
  }

  async findByRelatedEntity(
    assetId: string,
    relatedEntityType: RelatedEntityType,
    relatedEntityId: string
  ): Promise<TaskDto[]> {
    const response = await this.axiosInstance.get<TaskDto[]>(`/assets/${assetId}/tasks`, {
      params: { relatedEntityType, relatedEntityId },
    });
    return response.data;
  }

  async findMyPendingTasks(): Promise<MyTaskSummaryDto[]> {
    const response = await this.axiosInstance.get<MyTaskSummaryDto[]>('/user/me/tasks');
    return response.data;
  }
}
